import axios from 'axios'
axios.defaults.withCredentials = true
export const getNewWordExamUsers = function (num) {
  let url = `https://reciteword.youdao.com/appapi/wordExam/getNewWordExamUsers?num=${num}`
  return axios.get(url)
}
export const getVocabulary = function (start, end) {
  let url = `https://reciteword.youdao.com/appapi/wordExam/getExamWord?start=${start}&end=${end}`
  return axios.get(url)
}
export const recommendBook = function (wordNumber) {
  let url = `https://reciteword.youdao.com/appapi/wordExam/getRecommendBooks?wordNumber=${wordNumber}`
  return axios.get(url)
}
export const getWordFrequencyRank = function () {
  let url = `https://reciteword.youdao.com/appapi/wordExam/getWordFrequencyRank`
  return axios.get(url)
}
export const getUserInfo = function () {
  let url = `https://reciteword.youdao.com/appapi/getUserProfile`
  return axios.get(url)
}
export const saveWordExamResult = function (num) {
  let url = `https://reciteword.youdao.com/appapi/wordExam/saveWordExamResult?wordNumber=${num}`
  return axios.get(url)
}


// WEBPACK FOOTER //
// ./src/libs/sever.js